/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default angular.module('thingsboard.api.signup', [])
    .factory('signUpService', SignUpService)
    .name;

/*@ngInject*/
function SignUpService($http, $q, userService) {

    var service = {
        signup: signup,
        acceptPrivacyPolicy: acceptPrivacyPolicy,
        deleteTenantAccount: deleteTenantAccount,
        isDisplayWelcome: isDisplayWelcome,
        setNotDisplayWelcome: setNotDisplayWelcome
    };

    return service;

    function signup(signupRequest) {
        var deferred = $q.defer();
        $http.post('/api/noauth/signup', signupRequest).then(function success(response) {
            deferred.resolve(response);
        }, function fail(response) {
            deferred.reject(response);
        });
        return deferred.promise;
    }

    function acceptPrivacyPolicy() {
        var deferred = $q.defer();
        $http.post('/api/signup/acceptPrivacyPolicy').then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteTenantAccount() {
        var deferred = $q.defer();
        $http.delete('/api/signup/tenantAccount').then(function success(response) {
            deferred.resolve(response);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function isDisplayWelcome() {
        var deferred = $q.defer();
        if (userService.getAuthority() === 'TENANT_ADMIN') {
            $http.get('/api/signup/displayWelcome').then(function success(response) {
                deferred.resolve(response.data);
            }, function fail() {
                deferred.resolve(false);
            });
        } else {
            deferred.resolve(false);
        }
        return deferred.promise;
    }

    function setNotDisplayWelcome() {
        var deferred = $q.defer();
        $http.post('/api/signup/notDisplayWelcome').then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
}